// globals: jQuery, Ajax, reportAjaxError, TakePayment
/**
 * @param initConfig
 */
export default class CashFlowIframeAbstract {
  constructor(defaultConfig) {
    this.config = defaultConfig ? { ...defaultConfig } : {};
  }

  init(initConfig) {
    if (initConfig) {
      this.config = { ...this.config, ...initConfig };
    }

    const defaultFirstName = 'Primary';
    const defaultLastName = 'User';
    let firstName = document.querySelector('#first_name')?.value ?? defaultFirstName;
    let lastName = document.querySelector('#last_name')?.value ?? defaultLastName;

    const cashFlowIframeUrl = document.querySelector('#gatewayIframeUrl')?.value;
    const systemId = document.querySelector('#ccSystemId')?.value;
    const systemIdAch = document.querySelector('#achSystemId')?.value;
    const cashFlowCcPublicKey = document.querySelector('#gatewayCcPublicKey')?.value;
    const cashFlowAchAccountId = document.querySelector('#gatewayAchAccountId')?.value;
    const cashFlowAchPublicKey = document.querySelector('#gatewayAchPublicKey')?.value;
    const memberId = document.querySelector('#member_id')?.value;
    const cssLayout = 'width: 100%;height: auto; margin-bottom:40px; display:grid';
    const userId = document.querySelector('#user_id')?.value;
    const defaultSystemId = Date.now();
    const memberUserID = userId ?? memberId;
    const uniqueId = memberUserID ?? defaultSystemId;
    let iframeStyle = '';
    const errorMessage = '';
    let html = errorMessage;
    let cvvVal;
    let ccName;
    let postalCode;
    let idtechSecureKey;

    if (userId && this.config.iframeLocation !== 'pos') {
      cvvVal = 'false';
      ccName = 'false';
      postalCode = 'false';
      if (typeof memberId !== 'undefined' && memberId === userId) {
        cvvVal = 'true';
      }
    } else if (document.querySelector('#agreements')?.value === 'v1') {
      cvvVal = 'false';
      ccName = 'false';
      postalCode = 'false';
    } else {
      cvvVal = 'false';
      ccName = 'true';
      postalCode = 'true';
      const personalName = document.getElementById('personalName') ?? '';
      if (personalName) {
        const memberFullName = personalName.innerText;
        firstName = memberFullName.split(' ').slice(0, -1).join(' ');
        lastName = memberFullName.split(' ').slice(-1).join(' ');
      }
    }
    if (this.config.iframeLocation === 'profile' && document.querySelector('#paymenttype')?.value === undefined) {
      cvvVal = 'true';
    }

    if (document.querySelector('#idtechSecureKeyEnabled')?.value) {
      idtechSecureKey = true;
    } else {
      idtechSecureKey = false;
    }

    if (this.config.iframeLocation === 'profile') {
      if (document.querySelector('#paymenttype')?.value === 'bank') {
        html += `<tokenize-payment-method public-key="${cashFlowAchPublicKey}" style = "${cssLayout}" service-uri="${cashFlowIframeUrl}" system-id="${systemIdAch}" wallet-id="" phone="" country="" type="2" hasEmailField = "false" has-name-field="true" has-submit-button = "false" is-save-for-future-use = "true" is-offline = "true"></tokenize-payment-method>`;
        html += '<button name="useExternalButton" id="useExternalButton" type="button" class="emv-terminal-btn-cashflow btn btn-primary external-ach">Continue</button>';
        jQuery(`#${this.config.frameContainer}`).html(html);

        // Works when user clicks on external button
        jQuery('#useExternalButton').click(() => {
          const addBankElement = document.querySelector('tokenize-payment-method');
          const iframe = addBankElement.shadowRoot.querySelector('#tokenize-iframe-cashflow');
          iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, cashFlowIframeUrl);
        });

        const addBankElement = document.querySelector('tokenize-payment-method');
        addBankElement.addEventListener('paymentAddedSuccess', (event) => {
          const data = event.detail;
          jQuery('.cashFlowIframeError').html('');
          const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
          const cardnumber = data.bankIdentifier;
          const checkingAccount = 1;
          const savingAccount = 2;
          const otherAccountType = 5;
          const bankAccountValue = 'Checking account';
          const firstBnk = cardnumber.substring(0, 1); // used for card connect
          const lastTwo = cardnumber.substring(cardnumber.length - 2); // used for card connect
          const masked = cardnumber.substring(1, cardnumber.length - 2).replace(/\d/g, '*'); // used for card connect
          const maskedVal = firstBnk + masked + lastTwo; // used for card connect
          const lastFour = cardnumber.substring(cardnumber.length - 4);
          const bankAccountType = data.accountType === bankAccountValue ? checkingAccount : savingAccount;
          $form.find('[name=checking_account_number]').val(data.lastFourDigits).prop('readonly', true);
          $form.find('[name=account_number]').val(data.lastFourDigits).prop('readonly', true);
          $form.find('[name=account_number2]').val(data.lastFourDigits);
          $form.find('[name=routing_number]').val(data.bankIdentifier).prop('readonly', true);
          $form.find('[name=bank_account_type]').val(bankAccountType).change();
          $form.find('[name=title]').val(data.name);
          jQuery('#payment_processor_unique_id').val(data.token);
          const myselect = (data.accountType === otherAccountType || data.accountType === bankAccountValue) ? checkingAccount : savingAccount;
          jQuery('#bnkifm').parents('.ui-dialog').find('.ca-titlebar-close').click();
          jQuery(`#bank_account_type option[value='${myselect}']`).prop('selected', 'selected');
          this.setCashFlowParamsToFormBank($form, data, () => {
            this.onSuccess($form, data);
          });
        });
        addBankElement.addEventListener('paymentAddedFailure', (event) => {
          if (typeof (event.detail.message) !== 'undefined') {
            const tokenizationErrorAlert = jQuery('.tokenization-error-alert');
            const caTitlebarClose = tokenizationErrorAlert.find('.ca-titlebar-close');
            caTitlebarClose.click();
            jQuery.caAlert(
              event.detail.message,
              '',
              {className: 'tokenization-error-alert'}
            );
          }
        });
      } else {
        // To iframe use for Member agreement and Staff portal
        html += `<tokenize-payment-method public-key="${cashFlowCcPublicKey}" style = "${cssLayout}" service-uri="${cashFlowIframeUrl}" last-name="${lastName}" first-name="${firstName}" system-id="${systemId}" wallet-id="" phone="" country="" type="1" show-card-preview="false" has-cvv-field="${cvvVal}" has-name-field="${ccName}"  has-postal-code-field = "${postalCode}" has-submit-button = "false" is-save-for-future-use = "true" has-pos-device-support=${idtechSecureKey}></tokenize-payment-method>`;
        html += '<input type="hidden" value="" name="mytoken" id="mytoken" />';
        html += '<input type="hidden" value="" name="myexpiry" id="myexpiry" />';
        html += '<button name="useExternalButton" id="useExternalButton" type="button" class="emv-terminal-btn-cashflow btn btn-primary external-cc">Continue</button>';
        jQuery(`#${this.config.frameContainer}`).html(html);

        // Works when user clicks on external button
        jQuery('#useExternalButton').click(() => {
          const addCardElement = document.querySelector('tokenize-payment-method');
          const iframe = addCardElement.shadowRoot.querySelector('#tokenize-iframe-cashflow');
          iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, cashFlowIframeUrl);
        });

        const addCardElement = document.querySelector('tokenize-payment-method');
        addCardElement.addEventListener('posDeviceListening', (event) => {
          const useExternalButton = document.getElementById('useExternalButton');
          const useEmvTerminalBtn = document.getElementById('useEmvTerminalBtn');
          if (event.detail.isListening == true) {
            useExternalButton.style.display = 'none';
            useEmvTerminalBtn.style.display = 'none';
          } else {
            useExternalButton.style.display = 'block';
            useEmvTerminalBtn.style.display = 'block';
          }
        });
        addCardElement.addEventListener('paymentAddedSuccess', (event) => {
          this.paymentAddedSuccessDefault(event);
        });
        addCardElement.addEventListener('paymentAddedFailure', (event) => {
          if (typeof (event.detail.message) !== 'undefined') {
            const tokenizationErrorAlert = jQuery('.tokenization-error-alert');
            const caTitlebarClose = tokenizationErrorAlert.find('.ca-titlebar-close');
            caTitlebarClose.click();
            jQuery.caAlert(
              event.detail.message,
              '',
              {className: 'tokenization-error-alert'}
            );
          }
        });
      }
    } else if (this.config.iframeLocation === 'pos') {
      html += `<tokenize-payment-method public-key="${cashFlowCcPublicKey}" styles="" service-uri="${cashFlowIframeUrl}" last-name="${lastName}" first-name="${firstName}" system-id="${systemId}" wallet-id="" phone-number = "false" country="" type="1" show-card-preview="false" has-cvv-field="true" name-required="false" has-submit-button = "true" is-save-for-future-use = "true" has-pos-device-support=${idtechSecureKey}></tokenize-payment-method>`;
      html += '<input type="hidden" value="" name="mytoken" id="mytoken" />';
      html += '<input type="hidden" value="" name="myexpiry" id="myexpiry" />';
      html += '<input type="hidden" value="" name="ccType" id="ccType" />';
      jQuery(`#${this.config.frameContainer}`).html(html);
      const addCardElement = document.querySelector('tokenize-payment-method');
      // event listener
      addCardElement.addEventListener('paymentAddedSuccess', (event) => {
        jQuery('.ca-loading-splash-container').css('display', 'block');
        jQuery('.overlay_layer').css('display', 'block');
        const data = event.detail;
        const mytoken = document.getElementById('mytoken');
        const myexpiry = document.getElementById('myexpiry');
        const ccType = document.getElementById('ccType');
        if (typeof (data.token) !== 'undefined' && typeof (data.expirationDate) !== 'undefined') {
          mytoken.value = data.token;
          myexpiry.value = data.expirationDate;
          ccType.value = data.brand;
        }
        const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
        this.setCashFlowParamsToForm($form, data, () => {
          this.onSuccess($form, data);
        });
        var url = '/payment/take-payment?&ajax=true';
        if (window.location.href.includes('noframe=1')) {
          url += '&noframe=1';
        }
        showAjaxStarted();
        new Ajax.Request(
          url,
          {
            method: 'post',
            parameters: jQuery('#takePaymentForm, #pos_form').serialize(),
            onComplete(response) {
              showAjaxFinished();
              jQuery('#take_payment').html(response.responseText);
              jQuery('.ca-loading-splash-container').css('display', 'none');
              jQuery('.overlay_layer').css('display', 'none');
            },
            onFailure() {
              showAjaxFinished();
              jQuery.caAlert('fail');
              jQuery('.ca-loading-splash-container').css('display', 'none');
              jQuery('.overlay_layer').css('display', 'none');
            },
          },
        );
      });
    } else if (this.config.iframeLocation === 'partner') {
      let styles = '';
      if (typeof (this.config.cssRules) !== 'undefined') {
        styles = JSON.stringify(this.config.cssRules);
      }

      if (document.querySelector('#paymentType')?.value === 'bank') {
        // To iframe use for Member agreement and Staff portal
        html += `<tokenize-payment-method 
                      public-key="${cashFlowAchPublicKey}" 
                      style = "${cssLayout}" 
                      service-uri="${cashFlowIframeUrl}" 
                      system-id="${systemIdAch}" 
                      wallet-id="" 
                      phone="" 
                      country="" 
                      type="2" 
                      hasEmailField = "false"
                      has-name-field="${ccName}"
                      has-submit-button = "true" 
                      is-save-for-future-use = "true"
                      styles=${styles}
                      ></tokenize-payment-method>`;
        jQuery(`#${this.config.frameContainer}`).html(html);

        const addBankElement = document.querySelector('tokenize-payment-method');
        addBankElement.addEventListener('paymentAddedSuccess', (event) => {
          const data = event.detail;
          const checkingAccount = 1;
          const savingAccount = 2;
          const bankAccountValue = 'Checking account';
          const bankAccountType = data.accountType === bankAccountValue ? checkingAccount : savingAccount;
          data.account_type = bankAccountType;
          data.ca_token = document.querySelector('#ca_token')?.value;
          jQuery('.cashFlowIframeError').html('');
          const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
          this.onSuccess($form, data);
        });
        addBankElement.addEventListener('paymentAddedFailure', (event) => {
          if (typeof (event.detail.message) !== 'undefined') {
            jQuery.caAlert(event.detail.message);
          }
        });
      } else {
        // To iframe use for Member agreement and Staff portal
        html += `<tokenize-payment-method 
                      public-key="${cashFlowCcPublicKey}" 
                      style = "${cssLayout}" 
                      service-uri="${cashFlowIframeUrl}" 
                      system-id="${systemId}" 
                      wallet-id="" 
                      phone="" 
                      country="" 
                      type="1" 
                      show-card-preview="false" 
                      has-cvv-field="true" 
                      has-name-field="${ccName}"  
                      has-postal-code-field = "${postalCode}" 
                      has-submit-button = "true" 
                      is-save-for-future-use = "true"
                      component-location="nested"
                      styles=${styles}
                      ></tokenize-payment-method>`;
        html += '<input type="hidden" value="" name="mytoken" id="mytoken" />';
        html += '<input type="hidden" value="" name="myexpiry" id="myexpiry" />';
        jQuery(`#${this.config.frameContainer}`).html(html);

        const addCardElement = document.querySelector('tokenize-payment-method');
        addCardElement.addEventListener('paymentAddedSuccess', (event) => {
          this.paymentAddedSuccessDefault(event);
        });
        addCardElement.addEventListener('paymentAddedFailure', (event) => {
          if (typeof (event.detail.message) !== 'undefined') {
            jQuery.caAlert(event.detail.message);
          }
        });
      }
    }

    if (typeof (this.config.iframeStyle) !== 'undefined') {
      iframeStyle = this.config.iframeStyle;
    }

    const setCCData = function ($form, data) {
      const CCInfoDate = data.expirationDate.split('/');
      const getDate = new Date();
      const getYear = getDate.getFullYear().toString().slice(0, 2);
      const expirationYear = `${getYear}${CCInfoDate[1]}`;
      let expirationMonth = CCInfoDate[0];
      if (expirationMonth.length === 1) {
        expirationMonth = `0${expirationMonth}`;
      }
      const expirationDate = `${expirationYear}-${expirationMonth}-01`;
      const ccNumberEscape = `${Array(13).join('*')}${data.lastFourDigits}`;
      $form.find('[name=cc_date]').val(expirationDate);
      $form.find('[name=cc_number]').val(ccNumberEscape);
      $form.find('#cc_date-month').val(expirationMonth);
      $form.find('#cc_date-year').val(expirationYear);
      jQuery('#cc_date').val(expirationYear + expirationMonth);
      jQuery('#cc_merchant_unique_id').val(data.token);
      jQuery('#cc_type').val(data.brand);
      const firstDiv = jQuery('#cashFlowFrameFormDialog').parent().parent().parent()
        .find('div:first');
      const nearestChildDiv = firstDiv.children('div');
      const nearestLink = nearestChildDiv.find('a');
      nearestLink.click();
    };

    if (this.config.isEmvTerminal) {
      const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
      const $useEmvTerminalBtn = jQuery(this.config.formSelector)
        .find('#useEmvTerminalBtn');
      $useEmvTerminalBtn.removeClass('hidden');
      $useEmvTerminalBtn.on('click', () => {
        TakePayment.callTokenizationTerminal(
          {},
          (data) => {
            setCCData($form, data);
          },
        );
      });
    }
  }

  paymentAddedSuccessDefault(event) {
    const data = event.detail;
    const mytoken = document.getElementById('mytoken');
    const myexpiry = document.getElementById('myexpiry');
    if (typeof (data.token) !== 'undefined' && typeof (data.expirationDate) !== 'undefined') {
      mytoken.value = data.token;
      myexpiry.value = data.expirationDate;
      jQuery('#cc_type').val(data.brand);
    }
    jQuery('.cashFlowIframeError').html('');

    const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
    this.setCashFlowParamsToForm($form, data, () => {
      this.onSuccess($form, data);
    });
  }

  onEmvSuccess() {
    // Interface needed after on success of emv payment
  }

  openEmvTerminal() {
    TakePayment.callTerminal(
      {},
      (data) => {
        const $dialogContent = jQuery('<div>'
                    + '<p class="pos-terminal-text">Please process payment through the EMV terminal.</p>'
                    + '</div>');

        const url = '/payment/emv-terminal-create-token';

        new Ajax.Request(
          url,
          {
            method: 'post',
            parameters: data,
            onComplete(request) {
              $dialogContent.caDialog('close');
              const { responseJSON } = request;
              if (request.status === 0) {
                return false;
              }
              if (responseJSON.status === 1) {
                this.onEmvSuccess(responseJSON.token);
              }
            },
            onFailure: reportAjaxError,
          },
        );
        $dialogContent.caDialog({
          title: 'Transaction In Progress...',
          resizable: false,
          width: 600,
          showCloseButton: false,
          modal: true,
        });
      },
    );
  }

  onSuccess() {
    // Interface needed after on success of card payment
  }

  /**
     * @param $form
     * @param data
     * @param callback
     */
  setCashFlowParamsToForm($form, data, callback) {
    const array = data.expirationDate.split('/');
    let expiration_month = array[0];
    const date = new Date();
    const year = date.getFullYear().toString().slice(0, 2);
    const expiration_year = `${year}${array[1]}`;

    if (expiration_month.length === 1) {
      expiration_month = `0${expiration_month}`;
    }

    const expiration_date = `${expiration_year}-${expiration_month}-01`;

    const ccNumberEscape = `${Array(13).join('*')}${data.lastFourDigits}`;
    const activeGatewayAll = jQuery('#activeGatewayAll').val();
    const houseCharge = jQuery('#house_charge').val();
    $form.find('[name=cc_date]').val(expiration_date);
    $form.find('[name=cc_number],[name="ccInfo[ccNumber]"],[name=card_number]').val(ccNumberEscape);
    $form.find('[name=cc_name],[name="ccInfo[ccName]"],[name=ccName]').val(data.name);
    $form.find('#cc_date-month').val(expiration_month);
    if (expiration_month && expiration_month >= 1 && expiration_month <= 12) {
      $form.find('#cc_date-m,#cc_date-mth').val(parseInt(expiration_month));
    }
    $form.find('#cc_date-year,#cc_date-Y,#cc_date-yr').val(expiration_year);
    jQuery('#ccInfo-ccNumber').val(ccNumberEscape);
    jQuery('#cc_date').val(expiration_year + expiration_month);
    jQuery('#myexpiry').val(expiration_year + expiration_month);
    jQuery('#ccInfo-expDate').val(expiration_year + expiration_month);

    jQuery('#cc_merchant_unique_id').val(data.token);
    jQuery('#creditCardType').val(data.brand);

    const ccIconElement = jQuery('#cc_icon');
    ccIconElement.attr('class', `cc_${data.brand.toLowerCase()}`);
    ccIconElement.css('display', '');
    jQuery('#addCCButton').attr('value', 'Update');
    if (activeGatewayAll === 'cashflow' && houseCharge === 'credit card') {
      jQuery('.cash_cc_name').prop('readonly', true);
      jQuery('.cash_cc_date').css('pointer-events', 'none');
    }
    $form.find('[name=cc_merchant_unique_id]').val(data.token);
    data.expiration_month = expiration_month;
    data.expiration_year = expiration_year;
    data.cc_merchant_unique_id = data.token;
    data.cc_type = data.brand;
    data.cc_number = ccNumberEscape;
    callback();
  }

  setCashFlowParamsToFormBank($form, data, callback) {
    const accountNumberEscape = data.lastFourDigits;
    let accountType;
    // Returns Checking account for Checkings Ach ACCOUNT From CashFlow
    if (data.accountType === 'Checking account') {
      accountType = 'Checkings';
    } else {
      accountType = 'Savings';
    }
    data.account_type = accountType;
    data.routing_number = data.bankIdentifier;
    data.ba_merchant_unique_id = data.token;
    data.account_number = accountNumberEscape;
    callback();
  }
}
